// extracted by mini-css-extract-plugin
module.exports = {"userRole":"userRole_userRole__3QFhz","admin":"userRole_admin__Z7eJ1","customerAdmin":"userRole_customerAdmin__2SXDa","support":"userRole_support__3jC23"};